import Phaser from "phaser";
export default class WinScene extends Phaser.Scene {

    constructor() {
        super('win-scene')
    }

    init(data){
        this.replayButton = undefined
        this.score = data.score
    }

    preload() {
        this.load.image('background', 'images/bg_layer1.png')
        this.load.image('win-bg', 'images/win.png')
        this.load.image('replay-button', 'images/replay.png')
    }

    create(){
        this.add.image(240, 320, 'background')
        this.add.image(240, 280, 'win-bg').setScale(0.35)

        this.add.image(256, 250, 'bg-gameover')
        this.add.image(256, 250, 'game-over-text')

        this.add.text(180, 125, 'Score: ', {
			fontSize: '33px',
			color: '#FFD700',
		});
		this.add.text(300, 125, this.score, {
			fontSize: '33px',
			color: '#FFD700',
		});

        this.replayButton = this.add.image(240, 420, 'replay-button').setInteractive()

        // ketika di klik, scene akan berpindah ke BunnyJumpScene
        this.replayButton.once('pointerup', () => {
            this.scene.start('math-fighter-scene')
        }, this)
        
    }
}